<form [formGroup]="form">
  @if (showSeparator) {
    <hr />
  }
  <ng-template
    [ngTemplateOutlet]="titleTemplate || defaultTitleTemplate"
    [ngTemplateOutletContext]="{ title: title, groupAdded: addNewGroup }"
  ></ng-template>
  @if (isTemplate(validatorsMessageTemplate)) {
    <ng-template [ngTemplateOutlet]="validatorsMessageTemplate" [ngTemplateOutletContext]="{ items: items }"></ng-template>
  } @else {
    @if (validatorsMessageTemplate) {
      <div class="row">
        <div class="mb-3 text-secondary col-12">
          <small class="form-text">{{ validatorsMessageTemplate }}</small>
        </div>
      </div>
    }
  }
  <div formArrayName="items">
    @if (items.controls.length > 0) {
      @for (group of items.controls; track group; let groupIndex = $index) {
        <div class="row">
          <ng-template
            [ngTemplateOutlet]="contentTemplateRef"
            [ngTemplateOutletContext]="{ groupIndex: groupIndex, group: group, groupRemoved: removeGroup }"
          ></ng-template>
        </div>
      }
    } @else {
      <div class="col-12 mb-2">
        <p>
          <span>{{ noGroupText }}</span>
        </p>
      </div>
    }
  </div>
  <ng-template #defaultTitleTemplate>
    <div class="row">
      <div class="col-12">
        <div class="d-flex justify-content-between">
          <h5 class="text-primary">{{ title }}</h5>
          <button type="button" class="btn btn-primary" ngbTooltip="Ajouter" placement="left" (click)="addNewGroup()" [disabled]="disabled">
            <fa-icon icon="plus"></fa-icon>
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</form>
